import { put, call, takeLatest, select, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';


function* bestpartnerListGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/bestpartnerListApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "BESTPARTNER_LIST_SET",
        payload: {
          list: res.data.list,
          page: action.payload.page,
          isListNext: res.data.isListNext,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }

  yield put(loadingSet(false));
}

function* bestpartnerRead(action) {
  const state = yield select();
  yield put(loadingSet(true));
  const {res} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'read');
    params.append('mailId', payload.mailId);
    return axios.post(config.apiUri + "member/bestpartnerEdit.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      yield put({
        type: "BESTPARTNER_ITEM_SET",
        payload: {
          type: 'read',
          mailId: action.payload.mailId,
        },
      });
      yield delay(600);
      if (state.notification.bestpartnerUnconfirmed > 0) {
        yield put({type: 'NOTIFICATION_GET'});
      }
    }
  }
  yield put(loadingSet(false));
}

function* bestpartnerItemDel(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'del');
    params.append('mailId', payload.mailId);
    return axios.post(config.apiUri + "member/bestpartnerEdit.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      yield put({
        type: "BESTPARTNER_ITEM_SET",
        payload: {
          type: 'del',
          mailId: action.payload.mailId,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


const saga = [
  takeLatest('BESTPARTNER_LIST_GET', bestpartnerListGet),
  takeLatest('BESTPARTNER_READ', bestpartnerRead),
  takeLatest('BESTPARTNER_ITEM_DEL', bestpartnerItemDel),
];

export default saga;
